
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zakljuci-registracijo",
      function () {
        return require("private-next-pages/zakljuci-registracijo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zakljuci-registracijo"])
      });
    }
  